import { render, staticRenderFns } from "./GenerationContentCategoryDetails.vue?vue&type=template&id=1fd779db&"
import script from "./GenerationContentCategoryDetails.vue?vue&type=script&lang=js&"
export * from "./GenerationContentCategoryDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports